import { configureStore } from "@reduxjs/toolkit";
import linkReducer from '../features/nav/linkSlice'

export const store = configureStore({
    reducer:{
        link:linkReducer
    }
})